<template>
    <div class="fill-height">
        <v-card class="rounded-lg fill-height" justify="center">
            <v-tabs v-model="tab">
                <v-tab v-if="app.show100ms">100ms</v-tab>
                <v-tab>Integrations</v-tab>
                <v-tab>Webhooks</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" class="fill-height">
                <v-tab-item v-if="app.show100ms">
                    <one-hundred-ms-settings></one-hundred-ms-settings>
                </v-tab-item>
                <v-tab-item class="fill-height">
                    <integrations></integrations>
                </v-tab-item>
                <v-tab-item>
                    <webhooks></webhooks>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
import { useAppStore } from '../../stores/app'
import OneHundredMsSettings from '../../components/admin/OneHundredMsSettings.vue'
import Integrations from '../../components/admin/Integrations.vue'
import Webhooks from '../../components/admin/Webhooks.vue'

export default {
    name: 'Settings',
    components: { OneHundredMsSettings, Integrations, Webhooks, Webhooks },
    created: function() {
        this.app = useAppStore()
    },
    data: function() {
        return {
            app: null,
            user: null,
            rooms: [],
            loading: true,
            page_on_front: 0,
            settings: null,
            tab: parseInt(localStorage.getItem('admin_sub_tab')) ?? 0,
        }
    },
    mounted: function() {
        
    },
    methods: {
        
    },
    watch: {
        tab: function(newV, oldV) {
            localStorage.setItem('admin_sub_tab', newV)
        },
    }
}
</script>